import { MODE_ROAD, UNIT_CO2_UNKNOWN } from '@/lib/constants';
import { Co2Emission } from '@/lib/models/emissions/types';
import { EmissionStats } from '@/types';

import { mergeWtw } from '../merge-wtw';

/**
 * Merges and averages multiple Emission Stats into one
 */
export const mergeEmissionStats = (emissionStats: EmissionStats[]): EmissionStats | undefined => {
  const { unit } = emissionStats?.[0] || UNIT_CO2_UNKNOWN;
  const { mode } = emissionStats?.[0] || MODE_ROAD;

  const result = emissionStats.reduce(
    (accum, currentStat) => {
      if (currentStat && currentStat.average > 0) {
        return {
          min: Math.min(currentStat.min, accum.min),
          max: Math.max(currentStat.max, accum.max),
          sum: accum.sum + currentStat.average,
          wtw: mergeWtw(currentStat.wtw, accum.wtw),
          count: accum.count + 1,
        };
      }
      return accum;
    },
    {
      min: Infinity,
      max: 0,
      sum: 0,
      count: 0,
      wtw: undefined,
    } as {
      min: number;
      max: number;
      sum: number;
      count: number;
      wtw: Co2Emission | undefined;
    },
  );

  if (result.count > 0) {
    return {
      min: result.min,
      max: result.max,
      average: result.sum / result.count,
      unit,
      mode,
      wtw: result.wtw,
    };
  }

  return undefined;
};
